import Smartphones from 'Vacancies/views/VacancyView/containers/Smartphones'
import Tablets from 'Vacancies/views/VacancyView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const VacancyView = getCurrentDeviceView(Smartphones, Tablets)

export default VacancyView
